import 'satellite-polyfills';

import { createApp } from 'vue';
import Notifications from '@kyvg/vue3-notification';
import velocity from 'velocity-animate';
import { plugin as featureFlagPlugin } from '@loadsmart/vue-feature-flags';

import initSentry from '@satellite/plugins/sentry';

import App from './App.vue';
import router from './router';
import config from './config';

import { loadFonts } from './plugins/webfontloader';
import vuetify from './plugins/vuetifyPlugin';
import featureFlagConfig from './plugins/featureFlagPlugin';

loadFonts();

const initApp = async () => {
  const app = createApp(App);

  app.use(router);
  app.use(vuetify);
  app.use(Notifications, { velocity });
  app.use(featureFlagPlugin, { config: featureFlagConfig });

  initSentry(app, router, config);

  app.mount('#app');
};

initApp();
